<div class="toast relative">
  <div class="toast__container flex flex-col mt-14">
    @if (hiddenCount > 0) {
      <div class="toast__badge">
        <span class="toast__badge-span bg-primary text-white rounded-100 pl-1 pr-2 pt-1 pb-1">+{{ hiddenCount }}</span>
      </div>
    }
    @for (toast of visibleToasts; track toast; let i = $index) {
      <div class="flex flex-col">
        <app-toast [toast]="toast" (afterClosed)="finalRemoveToast($event)"></app-toast>
      </div>
    }
  </div>
</div>
